/* tslint:disable */
/* eslint-disable */
/**
 * Incendium AI API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
import { ApiReservedPageviewMetaFromJSON, ApiReservedPageviewMetaToJSON, } from './ApiReservedPageviewMeta';
import { ApiReservedPageviewMetaSelectorTypeFromJSON, ApiReservedPageviewMetaSelectorTypeToJSON, } from './ApiReservedPageviewMetaSelectorType';
export function ApiPageviewMetaTaggerPayloadFromJSON(json) {
    return ApiPageviewMetaTaggerPayloadFromJSONTyped(json, false);
}
export function ApiPageviewMetaTaggerPayloadFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'locationId': !exists(json, 'locationId') ? undefined : json['locationId'],
        'reserved': !exists(json, 'reserved') ? undefined : ApiReservedPageviewMetaFromJSON(json['reserved']),
        'selector': !exists(json, 'selector') ? undefined : json['selector'],
        'selectorType': !exists(json, 'selectorType') ? undefined : ApiReservedPageviewMetaSelectorTypeFromJSON(json['selectorType']),
        'value': !exists(json, 'value') ? undefined : json['value'],
    };
}
export function ApiPageviewMetaTaggerPayloadToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'locationId': value.locationId,
        'reserved': ApiReservedPageviewMetaToJSON(value.reserved),
        'selector': value.selector,
        'selectorType': ApiReservedPageviewMetaSelectorTypeToJSON(value.selectorType),
        'value': value.value,
    };
}
